import React from 'react'
import MenuItem from 'material-ui/MenuItem'

const buildMenuItems = (resource) => {
  return [
    <MenuItem primaryText='Edit' key='edit' value={`/ecommerce/product-discounts/${resource.id}/edit`} />,
    <MenuItem primaryText='Product' key='product' value={`/ecommerce/products/${resource.product_id}/edit`} />,
    <MenuItem primaryText='Discount' key='discount' value={`/ecommerce/discounts/${resource.discount_id}/edit`} />
  ]
}

export default buildMenuItems
